import { Button, cn } from '@crm/ui';
import { SlidersHorizontal } from 'lucide-react';
import { useState } from 'react';

interface FilterBarProps {
  /** O campo que sempre fica a vista - quase sempre a busca por texto. */
  search: React.ReactNode;
  /** Os demais filtros, que no celular so aparecem sob demanda. */
  children: React.ReactNode;
  /** Colunas do grid no desktop, ex.: `sm:grid-cols-2 lg:grid-cols-4`. */
  className?: string;
  /** Quantos filtros avancados estao valendo agora. */
  activeCount?: number;
}

/**
 * Barra de filtros das listagens. No celular a tela nao aguenta cinco campos
 * abertos: fica a busca com um botao ao lado, e o resto aparece quando o
 * usuario pede. Do tablet para cima todos os campos voltam a ser celulas do
 * mesmo grid - por isso o `sm:contents`, que dissolve os agrupamentos.
 */
export function FilterBar({ search, children, className, activeCount = 0 }: FilterBarProps) {
  const [isOpen, setOpen] = useState(false);

  return (
    <div className={cn('grid gap-3', className)}>
      <div className="flex items-center gap-2 sm:contents">
        <div className="min-w-0 flex-1 sm:contents">{search}</div>

        <Button
          variant="outline"
          onClick={() => setOpen((open) => !open)}
          aria-expanded={isOpen}
          aria-label="Busca avancada"
          title="Busca avancada"
          // Filtro escondido e filtro esquecido: com algum valor aplicado o
          // botao acende e mostra quantos sao.
          className={cn(
            'h-11 shrink-0 gap-2 px-3 sm:hidden',
            activeCount > 0 && 'border-primary text-primary',
          )}
        >
          {/* So o icone: ao lado do campo de busca ele ja diz o que e, e o
              rotulo comeria a largura que a busca precisa. */}
          <SlidersHorizontal />
          {activeCount > 0 ? (
            <span className="rounded-full bg-primary px-1.5 text-xs text-primary-foreground">
              {activeCount}
            </span>
          ) : null}
        </Button>
      </div>

      <div className={cn('gap-3 sm:contents', isOpen ? 'grid' : 'hidden')}>{children}</div>
    </div>
  );
}
